import { Isotipo, type LogoVariant } from './Isotipo';

/**
 * Lockup de marca: isotipo + wordmark.
 *
 * El wordmark se compone como texto en Poppins ExtraBold (norma del brandbook)
 * en lugar de trazarse como outlines. Ventajas: pesa cero bytes extra (la fuente
 * ya se carga), es seleccionable y accesible, y escala perfecto. Cuando llegue
 * el wordmark oficial vectorizado con su kerning propio, sustitúyalo aquí.
 *
 * La proporción entre símbolo y texto está fijada por `size`: no exponemos
 * anchos independientes para que sea imposible comprimir o extender el logo,
 * dos de los usos prohibidos del brandbook (p. 9).
 */

interface LogoProps {
  readonly variant?: LogoVariant;
  /** `lockup` = símbolo + texto en horizontal. `wordmark` = sólo texto. */
  readonly kind?: 'lockup' | 'wordmark';
  readonly className?: string;
}

const WORDMARK_COLOR: Record<LogoVariant, string> = {
  brand: 'text-brand',
  white: 'text-white',
  black: 'text-black',
};

export function Logo({
  variant = 'brand',
  kind = 'lockup',
  className = '',
}: LogoProps) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      {kind === 'lockup' && (
        // aria-hidden en el SVG (ver Isotipo) + el texto real al lado: un
        // lector de pantalla anuncia "togados" una sola vez, no dos.
        <Isotipo variant={variant} className="h-[1.15em] w-auto shrink-0" />
      )}
      <span
        className={`font-display text-[1em] leading-none font-extrabold tracking-[-0.01em] ${WORDMARK_COLOR[variant]}`}
      >
        togados
      </span>
    </span>
  );
}
